import type { DemoDocument } from "@/types/demo.types"

// =============================================================================
// Formatting Utilities
// =============================================================================

export function formatCurrency(value: number): string {
  if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`
  if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`
  return `$${value}`
}

// =============================================================================
// Status Utilities
// =============================================================================

export function getDocStatusVariant(status: DemoDocument["status"]): "default" | "success" | "warning" | "secondary" {
  switch (status) {
    case "signed": return "success"
    case "pending_review": return "warning"
    case "draft": return "secondary"
    default: return "default"
  }
}

export function getDocStatusLabel(status: DemoDocument["status"]): string {
  switch (status) {
    case "signed": return "Signed"
    case "pending_review": return "Pending Review"
    case "draft": return "Draft"
    default: return status
  }
}

export function getPriorityColor(priority: string): string {
  switch (priority) {
    case "high": return "text-red-400"
    case "medium": return "text-yellow-400"
    case "low": return "text-green-400"
    default: return "text-muted-foreground"
  }
}

// =============================================================================
// Permission Icons
// =============================================================================

import { Crown, Pen, Eye, Shield } from "lucide-react"

export function getPermissionIcon(permission: string) {
  switch (permission) {
    case "full_access": return Crown
    case "edit": return Pen
    case "review": return Eye
    default: return Shield
  }
}
